import { useState } from 'react';
import PropTypes from 'prop-types';

import formatEuros from '../../utils/formatEuros';

const MoneyInput = ({
  value,
  variant = 'outlined',
  label,
  id,
  hideLabel = false,
  alignRight = false,
  onChange,
}) => {
  const [highlight, setHighlight] = useState(false);
  const digits = Math.floor(100 * value);

  const handleKeyUp = (event) => {
    const { key } = event;
    const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    // helper to put decimal point to two places from the right end
    const placePoint = (s) => `${s.slice(0, -2)}.${s.slice(-2)}`;

    if (allowedKeys.includes(key)) {
      // add the pressed digit to the end of the string, put decimal point correctly
      const newValue = `${placePoint(`${digits}${key}`)}`;
      const numberValue = parseFloat(newValue);
      onChange(numberValue);
    }
    if (key === 'Backspace') {
      const newValue = Math.floor(digits / 10) / 100;
      onChange(newValue);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <label className={`pb-2 text-center ${hideLabel && 'hidden'}`} htmlFor={id}>
        {label}
      </label>
      <input
        className={`max-w-2xl rounded-lg border-0 border-b-2  border-transparent bg-pj-gray-500 px-6 py-4 font-semibold text-pj-gray-700 caret-transparent  ${
          variant === 'transparent'
          && 'w-full bg-transparent leading-none'
        }  ${
          variant === 'outlined' && 'w-full outline-none focus:ring-0'
        }  ${alignRight && 'text-right'} ${
          variant === 'transparent' && highlight && 'outline-none focus:ring'
        }`}
        type="text"
        id={id}
        value={formatEuros(value)}
        onChange={() => {}}
        onKeyUp={handleKeyUp}
        onFocus={() => setHighlight(true)}
        onBlur={() => setHighlight(false)}
      />
    </div>
  );
};

MoneyInput.propTypes = {
  value: PropTypes.number.isRequired,
  variant: PropTypes.oneOf(['outlined', 'transparent']),
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  hideLabel: PropTypes.bool,
  alignRight: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default MoneyInput;
